import { setLoading } from 'checkout/actions/loading';
import { isReservationFullyPaid } from 'checkout/selectors/reservation';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addPayment, setStripePaymentIntentSecret, setStripePaymentIntentId, createStripePaymentIntent, cancelStripePaymentIntent, finalizeReservationFromPaymentIntent, setStripeSubmittedPayment } from '../../../actions/payment';
import { addServerErrors, clearAlerts, goToConfirmation, setPaymentHandlesSubmission } from '../../../actions/ui';
import { GATEWAY_TYPE_STRIPE } from '../../../reducers/payment';
import { getDefaultAddress } from '../../../selectors/member';
import { setDeliveryAddress, validateAndSaveDeliveryAddress } from '../../delivery/actions/delivery';
import { getSelectedDeliveryOption } from "../../../selectors/delivery";
import { hasDeliverableProducts } from '../../../selectors/product';
import { getCheckoutClient } from 'checkout/config/CheckoutClient';
import request from "superagent";
import Payment from '@showclix-shared/Payment/Payment';

class PaymentContainer extends Component {
    state = {
        selectedGatewayType: null,
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    getSelectedGatewayType = () => {
        return this.state.selectedGatewayType ?? this.props.gatewayType;
    }

    onPaymentSubmit = (payload, { onSuccess, onError }) => {
        getCheckoutClient(this.props.apiUrl)
            .reservationCreateRequest(this.props.token, 'payment', payload, this.props.secret)
            .then((result) => {
                onSuccess();
                this.onPaymentSuccess(result.body.data);
            }).catch(error => {
                onError();
                if(error.response && error.response.body) {
                    this.onPaymentFail(error.response.body.errors);
                } else {
                    this.onPaymentFail(error);
                }
            });
    }

    onGetCardinalData = ({ onSuccess, onError }) => {
        getCheckoutClient(this.props.apiUrl)
            .reservationCreateRequest(this.props.token, 'gateway/cardinal-commerce', {}, this.props.secret)
            .then((result) => {
                if (typeof result.body.data.attributes.jwt !== 'undefined' && result.body.data.attributes.jwt) {
                    onSuccess(result.body.data.attributes.jwt, result.body.data.attributes.jwt)
                }
            })
            .catch((error) => {
                onError()
                if (error.response && error.response.body) {
                  this.onPaymentFail(error.response.body.errors);
                } else {
                  this.onPaymentFail(error);
                }
            });
    }

    onThreeDSRequest = ({
        payload,
        reservation_secret
    }) => {
        let checkoutClient = getCheckoutClient(this.props.apiUrl);
        let url = this.props.originUrl + '/api/adyen_payments/3ds';
        let req = request.post(url);

        if (payload) {
          req.send(JSON.stringify(payload));
        }
        if (reservation_secret) {
          req.set('reservation-secret', reservation_secret);
        }
        req.set('Content-Type', 'application/json');
        return checkoutClient.executeRequest(req, 200);
    }

    onReservationWait = (payload, { onError, t }) => {
        return getCheckoutClient(this.props.apiUrl)
            .reservationCreateRequest(this.props.token, 'wait', payload, this.props.secret)
            .then(() => {
                return Promise.resolve(true);
            })
            .catch((error) => {
                onError();
                if (error.response && error.response.body?.errors && error.response.body?.errors[0]?.detail) {
                    this.onPaymentFail([{ detail: t.t(error.response.body.errors[0].detail) }]);
                } else {
                    this.onPaymentFail([{ detail: t.t('checkout__error_submit_payment') }]);
                }
                return Promise.reject('');
            });
    }

    onGatewayTypeChange = (gatewayType) => {
      this.setState({ selectedGatewayType: gatewayType });
    }

    render() {
        const paymentProps = {
          onPaymentInitiated: this.onPaymentInitiated,
          onPaymentSuccess: this.onPaymentSuccess,
          onPaymentFail: this.onPaymentFail,
          onPaymentSubmit: this.onPaymentSubmit,
          onGetCardinalData: this.onGetCardinalData,
          onReservationWait: this.onReservationWait,
          onThreeDSRequest: this.onThreeDSRequest,
          onGatewayTypeChange: this.onGatewayTypeChange,
          validateAndSaveDeliveryAddress: this.validateAndSaveDeliveryAddress,
          loading: this.props.routerTransitioning
        }

        return (
          <Payment
            {...this.props}
            {...paymentProps}
          />
        );
    }

    validateAndSaveDeliveryAddress = t => {
        const onInvalid = () => {
            this.onPaymentFail([{detail: t.t('checkout__complete_delivery_address_fields')}]);
        }
        const onError = () => {
            this.onPaymentFail([{detail: t.t('checkout__unable_update_delivery_data')}]);
        }
        return this.props.validateAndSaveDeliveryAddress(t, onInvalid, onError);
    }

    onPaymentInitiated = () => {
        this.props.setLoading("CHECKOUT_STEP_REQUEST");
    }

    onPaymentSuccess = (data) => {
        this.props.clearAlerts();
        this.props.setLoading("CHECKOUT_STEP_SUCCESS");
        this.props.addPayment(data);
        this.props.goToConfirmation();
    }

    onPaymentFail = (errors) => {
        const selectedGatewayType = this.getSelectedGatewayType();

        /**
         * Not clearing errors for stripe to attempt to address issue
         * where user gets sent to the top of the screen, but there is
         * no error message when they get there
         */
        if (+selectedGatewayType !== GATEWAY_TYPE_STRIPE) {
          this.props.clearAlerts();
        }

        /**
         * Not clearing errors for stripe to attempt to address issue
         * where user gets sent to the top of the screen, but there is
         * no error message when they get there
         */
        this.props.setLoading("CHECKOUT_STEP_FAILURE");
        this.props.addServerErrors(errors);
    }
}

const mapStateToProps = state => {
    return {
        email: state.member.email,
        name: state.member.name,
        token: state.reservation.token,
        secret: state.reservation.secret,
        amount: state.reservation.total_cost ? state.reservation.total_cost.amount : 0,
        country: state.reservation.country ? state.reservation.country : '',
        currency: state.reservation.total_cost ? state.reservation.total_cost.currency : '',
        tosAccepted: state.payment.tosAccepted,
        apiUrl: state.ui.apiUrl,
        phone: state.member.phone,
        acceptedCards: state.reservation.cardTypes,
        captureMethod: state.payment.method,
        isReservationFullyPaid: isReservationFullyPaid(state),
        createdNewAccount: state.member.createdNewAccount,
        emailOptOut: state.member.emailOptOut,
        gatewayType: state.payment.gatewayType,
        gatewayKey: state.payment.gatewayKey,
        gatewayLocation: state.payment.gatewayLocation,
        gatewayCountry: state.payment.gatewayCountry,
        gatewayLocale: state.payment.gatewayLocale,
        gatewayEnvironment: state.payment.gatewayEnvironment,
        merchantDescriptor: state.reservation.merchantDescriptor,
        jsUrl: state.payment.jsUrl,
        wallets: state.payment.wallets,
        originUrl: state.payment.gatewayOriginUrl,
        altGateways: Array.isArray(state.payment.altGateways) ? state.payment.altGateways : [],
        paymentIntentSecret: state.payment.stripePaymentIntentSecret,
        paymentIntentId: state.payment.stripePaymentIntentId,
        stripeSubmittedPayment: state.payment.stripeSubmittedPayment,
        locale: state.intl?.locale || 'en-US',
        routerTransitioning: !!state.router.transitioning,
        reservationPendingPaymentCompletion: !!state.reservation.isPendingPaymentCompletion,
        reservationIsCompleted: !!state.reservation?.isCompleted,
        defaultAddress: getDefaultAddress(state),
        deliveryAddress: state.delivery.address !== false ? state.delivery.address : getDefaultAddress(state),
        deliveryOption: getSelectedDeliveryOption(state),
        hasDeliverableProducts: hasDeliverableProducts(state),
        isPhoneRequired: state.weather?.quote?.selected ?? false
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        addServerErrors,
        addPayment,
        goToConfirmation,
        clearAlerts,
        setLoading,
        createStripePaymentIntent,
        cancelStripePaymentIntent,
        setPaymentHandlesSubmission,
        finalizeReservationFromPaymentIntent,
        setStripePaymentIntentSecret,
        setStripePaymentIntentId,
        setStripeSubmittedPayment,
        setDeliveryAddress,
        validateAndSaveDeliveryAddress,
    }, dispatch);
}

PaymentContainer.propTypes = {
    amount: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    secret: PropTypes.string.isRequired,
    tosAccepted: PropTypes.bool.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentContainer)
